import { CloseOutlined } from '@ant-design/icons';
import { useUsersCRUDActions } from '@mm/state/actions/UsersCRUDActions';
import CompanyModel from '@mm/state/model/CompanyModel';
import CompanyUsersModel from '@mm/state/model/CompanyUsersModel';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import React from 'react';
import { PrimaryButton } from '../../buttons/PrimaryButton/PrimaryButton';
import styles from './RemoveUserModal.module.css';

type Props = {
  company: CompanyModel;
  user: CompanyUsersModel;
};

export const RemoveUserModal = ({ company, user }: Props) => {
  const { closeModal } = useModalActions();
  const { delete: deleteUser } = useUsersCRUDActions();

  const showCompany = company.name.includes('company') ? '' : 'Company';

  const onRemoveUser = () => {
    deleteUser(company.id, user.id);
    closeModal();
  };

  return (
    <div className={styles.container}>
      <CloseOutlined className={styles.close} onClick={() => closeModal()} />

      <div className={styles.heading}>Remove a User</div>
      <div>
        Are you sure you want to remove {user.firstName} {user.lastName} from{' '}
        {company.name} {showCompany}?
      </div>
      <div className={styles.buttons}>
        <PrimaryButton
          onClick={() => closeModal()}
          color="transparent-no-shadow"
          className={styles.secondaryButton}
        >
          Cancel
        </PrimaryButton>
        <PrimaryButton
          onClick={() => onRemoveUser()}
          className={styles.primaryButton}
        >
          Remove
        </PrimaryButton>
      </div>
    </div>
  );
};
